import ENV from './env';
import { setChains, RemoteChain } from './chain';

const DEBUG_API_URL_KEY = 'DEBUG_API_URL';
const ENABLE_DEBUG_EDITOR_VIEW = 'ENABLE_DEBUG_EDITOR_VIEW';

export const getLocalDebugHost = () => {
  return localStorage.getItem(DEBUG_API_URL_KEY)?.trim();
};

export const getEnableEditorDebugger = () => {
  return Boolean(localStorage.getItem(ENABLE_DEBUG_EDITOR_VIEW));
};

const DEBUG_CHAINS = 'DEBUG_CHAINS';

const loadChains = () => {
  try {
    const lsChains = localStorage.getItem(DEBUG_CHAINS);

    if (lsChains) {
      const chains = JSON.parse(lsChains);
      setChains(chains);
    }
  } catch (error) {
    console.log('load chains error', error);
  }
};

if (!ENV.isProduction) {
  loadChains();

  (window as any).DEBUG = {
    setAPI(url?: string) {
      const _url = url?.trim();
      if (!_url) {
        localStorage.removeItem(DEBUG_API_URL_KEY);
        return;
      }
      localStorage.setItem(DEBUG_API_URL_KEY, _url);
    },
    saveChains(chains?: RemoteChain | RemoteChain[]) {
      try {
        setChains(chains);
        localStorage.setItem(
          DEBUG_CHAINS,
          JSON.stringify(Array.isArray(chains) ? chains : [chains]),
        );
      } catch (error) {
        console.log('set chains error', error);
      }
    },
  };
}
